import { pSifremiUnuttum, rCore, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';

export const action_api_set_input = (
  body: pSifremiUnuttum | null | undefined
): IInputAction<pSifremiUnuttum> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_SIFREMIUNUTTUM, true, body);

export const action_async_start = (body: pSifremiUnuttum): IPromiseAction<pSifremiUnuttum> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_SIFREMIUNUTTUM,
    new Api.User.SifremiUnuttum().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rCore | null | undefined,
  error: IError | null | undefined
): IApiAction<rCore> =>
  ActionFunctions.action_async_complete_api<rCore>(ActionSubTypes.API_SIFREMIUNUTTUM, data, error);
